/**
 * @file Shared React component — components/common/AnalysisBanner.tsx.
 */

import React from "react";
import "../../pages/Dashboard/Contributor/Contributor.css";

interface AnalysisBannerProps {
  title: string;
  subtitle?: string;
  /** Absolute URL or `/uploads/...` path (resolved by caller if needed). */
  imageUrl?: string;
}

const AnalysisBanner: React.FC<AnalysisBannerProps> = ({
  title,
  subtitle,
  imageUrl,
}) => {
  const hasImage = Boolean(imageUrl?.trim());
  return (
    <div
      className={
        hasImage ? "analysis-banner analysis-banner--with-image" : "analysis-banner"
      }
    >
      <div className="analysis-banner__text">
        <span className="analysis-banner__title">{title}</span>
        {subtitle && (
          <span className="analysis-banner__subtitle">{subtitle}</span>
        )}
      </div>
      {hasImage && (
        <div className="analysis-banner__thumb" aria-hidden>
          <img src={imageUrl} alt="" />
        </div>
      )}
    </div>
  );
};

/** React component — Analysis Banner. */
export default AnalysisBanner;

